import React, { useEffect, useState } from "react";
import { FaTimes, FaArrowRight } from "react-icons/fa";
import "./FlightPopup.css";

const FlightPopup = ({ onClose, onActionClick }) => {
  const [timeLeft, setTimeLeft] = useState(180); // 3 minutes

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = () => {
    const minutes = String(Math.floor(timeLeft / 60)).padStart(2, "0");
    const seconds = String(timeLeft % 60).padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  return (
    <>
      <div className="flight-popup-overlay" onClick={onClose}></div>
      <div className="flight-popup">
        <button className="close-btn" onClick={onClose}>
          <FaTimes />
        </button>
        <div className="popup-header">
          <h1 className="popup-brand">Reservation</h1>
          <p className="popup-offer">
            LIMITED TIME DEAL – <span>UP TO 25% OFF</span>
          </p>
          <p className="popup-timer">
            Offer valid for: <strong>{formatTime()}</strong>
          </p>
        </div>
        <p className="popup-support">24/7 Expert Travel Assistance</p>
        <div className="popup-agent">
          <img
            src="https://res.cloudinary.com/dyuskzmn3/image/upload/v1751742388/shot-of-a-businessman-using-a-computer-while-working-in-a-call-center_uwi1gg.jpg"
            alt="Travel Agent"
          />
        </div>
        <div className="popup-actions">
          <button onClick={onActionClick}>Flight Booking</button>
          <button onClick={onActionClick}>Manage Reservation</button>
          <button onClick={onActionClick}>Refund & Cancellation</button>
          <button onClick={onActionClick}>Customer Helpdesk</button>
        </div>
        <div className="popup-bottom" onClick={onActionClick}>
          <FaArrowRight /> <span>Secure Your Discount</span>
        </div>
      </div>
    </>
  );
};

export default FlightPopup;
